// PROPOSITO: el unico cliente de Supabase de toda la app.
// DEPENDENCIAS: @supabase/supabase-js, variables VITE_SUPABASE_*.
// NO OBVIO: solo src/services/ puede importar este archivo. Si lo importa una pantalla, un
// componente o un hook, es un bug de arquitectura y el guard scripts/check-fronteras.mjs rompe el
// build. La razon: redisenar una pantalla llegó a romper una consulta, y cada cambio costaba doble.

import { createClient } from '@supabase/supabase-js'
import { INTERRUPTORES } from '@/config/constantes'

const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

// En demo no hay base: los servicios devuelven datos de ejemplo antes de llegar aqui.
if (!INTERRUPTORES.demo && (!url || !anon)) {
  throw new Error(
    'Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY. Copia .env.example a .env.local.',
  )
}

// OJO: `||` y no `??`. Una variable de entorno ausente en el build llega como CADENA VACIA, no
// como undefined, y `??` la deja pasar tal cual. createClient('') lanza "supabaseUrl is required"
// antes del primer render y la app queda EN BLANCO, sin nada en pantalla. Solo se ve en el paquete
// construido, nunca en desarrollo.
export const supabase = createClient(url || 'http://demo.invalido', anon || 'demo', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'florfit.sesion',
  },
  global: {
    headers: { 'x-aplicacion': 'florfit-pwa' },
  },
  realtime: {
    params: { eventsPerSecond: 5 },
  },
})
